import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// ScriptsModalBody is a flex column with its own gap: 24 between children —
// pull SummaryList up via negative margin so the visible gap below the
// summary description is 12px instead of the full 24.
export const SummaryTitleBlock = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginBottom: -12,
});

export const SummaryDescription = styled(Typography)({
  flex: 1,
  fontSize: '14px',
  color: 'var(--am-text-secondary)',
  textAlign: 'center',
  '& strong': {
    color: 'var(--am-text-primary)',
  },
}) as typeof Typography;

export const SummaryList = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

export const SummaryRowPair = styled(Box)({
  display: 'flex',
  gap: 10,
  alignItems: 'stretch',
  '& > *': {
    flex: 1,
    minWidth: 0,
  },
});

export const LanguageBadgeRow = styled(Box)({
  display: 'flex',
  gap: 5,
  marginTop: 8,
  flexWrap: 'wrap',
});

export const LanguageBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$complete',
})<{ $complete: boolean }>(({ $complete }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  fontSize: 11,
  fontWeight: 600,
  padding: '3px 8px',
  borderRadius: 6,
  color: $complete ? 'var(--am-success-color)' : 'var(--am-text-disabled)',
  background: $complete ? 'var(--am-success-bg)' : 'var(--am-surface-2)',
  border: `1px solid ${$complete ? 'var(--am-success-color)' : 'var(--am-border)'}`,
}));
